var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-autocomplete',{attrs:{"items":_vm.items,"error-messages":_vm.errors,"item-text":"name","item-value":"id","outlined":"","dense":"","label":_vm.$t('type_id')},on:{"input":function($event){return _vm.$emit('input', _vm.value)}},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }